import { ShiftDigitalData } from '@/types/writeup';
import { SdEvents } from '@/types/sd-events';
import { generateElement } from '@/common/helpers';

export function createSDScript(shiftDigitalData: ShiftDigitalData) {
	const headScriptData = `
	var existingSDScript = document.querySelector(\`script[src="${shiftDigitalData.jsScriptUrl}"]\`) !== null;

	(function (i, s, o, g, r, a, m, n) {
		i['ShiftAnalyticsObject'] = r; i[r] = i[r] || function () {
			(i[r].q = i[r].q || []).push(arguments)
		}, i[r].l = 1 * new Date();
		if(!n) {
			a = s.createElement(o), m = s.getElementsByTagName(o)[0];
			a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
		}
		})(window, document, 'script', 'https:${shiftDigitalData.jsScriptUrl}', 'sendSDEvent', '', '', existingSDScript);

		if(typeof sd === 'function') {
			window.sendSDEvent = sd;
		}

		sendSDEvent('create', '${shiftDigitalData.clientId}', '${shiftDigitalData.retailerId}', '${shiftDigitalData.providerId}');
		var eventData = ${JSON.stringify(shiftDigitalData)};

		delete eventData.clientId;
    	delete eventData.retailerId;
    	delete eventData.jsScriptUrl;
		var sdDataLayer = {
			pageType: 'Digital Retailing',
			digRet: eventData,
			events: '${SdEvents.LoadPrecisePrice}',
			sessionId: '${shiftDigitalData.sessionId}'
		};
		sendSDEvent('dataLayer', sdDataLayer);
		sendSDEvent('send', 'pageview');`;

	generateElement(headScriptData, 'dr-sd-script', 'script', 'head');
}
